import styled from 'styled-components';

export const StyledMainMenuContainer = styled.div`
    display: flex;
    box-sizing: border-box;
    width: 100vw;
    max-width: 1340px;

    @media screen and (min-width: 577px) {
        & > input {
            display: none;
        }
    }

    @media screen and (max-width: 576px) {
    }
`;

export const StyledMainMenuWrapper = styled.div`
    @media screen and (min-width: 577px) {
        position: relative;
        width: 100%;
        max-width: 1340px;
        margin: 20px 0 20px 0;
    }

    @media screen and (max-width: 576px) {
        width: 100%;
    }
`;

export const StyledMainMenu = styled.header`
    position: relative;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    font-size: 16px;
    font-weight: 700;
    line-height: 20.4px;

    border-radius: 10px 10px 0 0;
    background-color: #ffffff;
    z-index: 2;

    @media screen and (min-width: 577px) {
        box-sizing: border-box;
        padding: 10px 40px;
        flex-direction: row;
        align-items: center;
        background-color: #ebebeb;
        border-radius: 20px;
        font-size: 16px;
        font-weight: 700;
        line-height: 20.4px;
    }

    @media screen and (max-width: 576px) {
        margin: 10px;
        padding: 10px;
    }
`;

export const StyledMainNav = styled.nav`
    position: relative;
    display: flex;
    width: 100%;
    align-items: center;
    color: #000000;
    background-color: #ffffff;

    & > a {
        margin: 10px 0;
        width: 100%;
    }

    & ul {
        display: flex;
        flex-direction: column;
    }

    ul a {
        display: inline-block;
        padding: 15px 0;
    }

    @media screen and (min-width: 577px) {
        text-wrap: nowrap;
        color: #6f6f6f;
        background-color: inherit;

        & > a {
            display: none;
        }

        ul {
            flex-grow: 1;
            flex-direction: row;
            justify-content: center;
        }

        ul > li {
            border: none;
        }

        ul > li {
            margin-right: 16%;
            padding: 0;
        }
    }

    @media screen and (max-width: 576px) {
        box-sizing: border-box;
        top: 100%;
        left: 0;
        display: none;
        width: 100%;
        padding: 10px;
        border-radius: 0 0 10px 10px;

        ul > li {
            border-bottom: 1px solid #dddddd;
        }

        & > span {
            display: block;
            padding: 15px 0;
        }
    }
`;
